// extracted by mini-css-extract-plugin
module.exports = {"grid":"SimilarDesigns_grid__DU8ns"};